<div class="col-sm-12">
  <h2>Status of Competition for Video Services in Michigan</h2>
</div>
<div class="Container well col-sm-12" *ngIf="!completionPage">
  <div class="row">
    <div class="col-sm-12">
      <h3>
        MPSC Annual Video/Cable Provider Survey - 2026
      </h3>
      <p>
        This survey is for all video/cable providers currently providing service
        in Michigan pursuant to Section 12(2) of the Uniform Video Services
        Local Franchise Act, Public Act 480 of 2006. The responses to this
        survey will provide the Michigan Public Service Commission with updated
        information regarding the status of video competition in Michigan for
        the {{ nextYear }} annual report as mandated by the Act.
        <strong>
          The completion of this survey is <i><u>required</u></i> by all
          video/cable providers operating within the state of Michigan.</strong
        >
      </p>
      <p>
        If you consider any or all of the information that you have submitted
        confidential, please indicate so at the end of the survey.
        <strong>
          Responses to this survey <u>must</u> be received by
          <u>DECEMBER 7, 2026</u
          >.</strong
        >
        Please submit only one survey response.
      </p>
      <p>
        Should you have any questions regarding this information request, please
        contact Erin West by email at
        <a href="mailto:  WestE1@michigan.gov"> WestE1@michigan.gov</a> or by
        phone at 517-284-8212.
      </p>
      <hr />
    </div>
  </div>

  <div class="row col-sm-12">
    <div class="form-group col-sm-4">
      <label for="companyName" class="control-label required"
        >Company Name</label
      >
      <input
        type="text"
        trim="blur"
        class="form-control"
        id="companyName"
        [formControl]="providerForm.controls['companyName']"
        [(ngModel)]="providerData.companyName"
        placeholder="Enter Franchise Entity"
        required
        name="companyName"
      />
      <div
        *ngIf="
          (providerForm?.controls['companyName']?.errors?.required ||
            providerForm?.controls['companyName']?.errors?.isValid) &&
          providerForm?.controls['companyName']?.touched
        "
        class="error-msg"
      >
        Franchise Entity is Required!
      </div>
    </div>
    <div class="form-group col-sm-4">
      <label for="address1" class="control-label required">Address</label>
      <input
        type="text"
        trim="blur"
        class="form-control"
        id="address1"
        [formControl]="providerForm.controls['address1']"
        [(ngModel)]="providerData.address1"
        placeholder="Enter Address"
        required
        name="Address1"
      />
      <div
        *ngIf="
          (providerForm?.controls['address1']?.errors?.required ||
            providerForm?.controls['address1']?.errors?.isValid) &&
          providerForm?.controls['address1']?.touched
        "
        class="error-msg"
      >
        Address is Required!
      </div>
    </div>
    <div class="form-group col-sm-4">
      <label for="address2" class="control-label">Address 2</label>
      <input
        type="text"
        trim="blur"
        class="form-control"
        id="address2"
        [formControl]="providerForm.controls['address2']"
        [(ngModel)]="providerData.address2"
        placeholder="Enter Address 2"
        name="address2"
      />
    </div>
  </div>

  <div class="row col-sm-12">
    <div class="form-group col-sm-4">
      <label for="city" trim="blur" class="control-label required"
        >City/Township/Village
      </label>
      <input
        type="text"
        class="form-control"
        id="city"
        [formControl]="providerForm.controls['city']"
        [(ngModel)]="providerData.city"
        placeholder="Enter City"
        required
        name="city"
      />
      <div
        *ngIf="
          (providerForm?.controls['city']?.errors?.required ||
            providerForm?.controls['city']?.errors?.isValid) &&
          providerForm?.controls['city']?.touched
        "
        class="error-msg"
      >
        City/Township/Village is Required!
      </div>
    </div>

    <div class="form-group col-sm-4">
      <label for="state" class="control-label required">State </label>
      <select
        name="state"
        id="state"
        class="form-control"
        [formControl]="providerForm.controls['state']"
        [(ngModel)]="providerData.state"
        required
      >
        <option value="undefined" disabled>Select A State</option>
        <option *ngFor="let state of allStates" [value]="state.stateName">
          {{ state.stateName }}
        </option>
      </select>
      <div
        *ngIf="
          (providerForm?.controls['state']?.errors?.required ||
            providerForm?.controls['state']?.errors?.isValid) &&
          providerForm?.controls['state']?.touched
        "
        class="error-msg"
      >
        State is Required!
      </div>
    </div>
    <div class="form-group col-sm-4">
      <label for="zip" class="control-label required">Zip </label>
      <input
        type="text"
        class="form-control"
        id="zip"
        [formControl]="providerForm.controls['zip']"
        [(ngModel)]="providerData.zip"
        placeholder="12345 or 12345-6789"
        required
        name="zip"
      />
      <div
        *ngIf="
          (providerForm?.controls['zip']?.errors?.required ||
            providerForm?.controls['zip']?.errors?.isValid) &&
          providerForm?.controls['zip']?.touched
        "
        class="error-msg"
      >
        Zip is Required!
      </div>
      <div
        *ngIf="
          providerData.zip != 'undefined' &&
          providerData.zip != null &&
          providerData.zip != '' &&
          providerForm?.controls['zip']?.errors?.invalidZip &&
          providerForm?.controls['zip']?.touched
        "
        class="error-msg"
      >
        Please enter a valid zip!
      </div>
    </div>
  </div>

  <div class="row col-sm-12">
    <div class="form-group col-sm-4">
      <label for="contactPerson" class="control-label required"
        >Contact Person
      </label>
      <input
        type="text"
        trim="blur"
        class="form-control"
        id="contactPerson"
        [formControl]="providerForm.controls['contactPerson']"
        [(ngModel)]="providerData.contactPerson"
        placeholder="Enter Contact Person"
        required
        name="contactPerson"
      />
      <div
        *ngIf="
          (providerForm?.controls['contactPerson']?.errors?.required ||
            providerForm?.controls['contactPerson']?.errors?.isValid) &&
          providerForm?.controls['contactPerson']?.touched
        "
        class="error-msg"
      >
        Contact Person is Required!
      </div>
    </div>
    <div class="form-group col-sm-4">
      <label for="title" class="control-label required">Title </label>
      <input
        type="text"
        trim="blur"
        class="form-control"
        id="title"
        [formControl]="providerForm.controls['title']"
        [(ngModel)]="providerData.title"
        placeholder="Enter title"
        required
        name="title"
      />
      <div
        *ngIf="
          (providerForm?.controls['title']?.errors?.required ||
            providerForm?.controls['title']?.errors?.isValid) &&
          providerForm?.controls['title']?.touched
        "
        class="error-msg"
      >
        Title is Required!
      </div>
    </div>

    <div class="form-group col-sm-4">
      <label for="phoneNumber" class="control-label required"
        >Direct Phone
      </label>
      <input
        type="text"
        [mask]="mask"
        class="form-control"
        id="phoneNumber"
        [formControl]="providerForm.controls['phoneNumber']"
        [(ngModel)]="providerData.phoneNumber"
        placeholder="Enter Direct Phone Number"
        required
        name="phoneNumber"
      />
      <div
        *ngIf="
          (providerForm?.controls['phoneNumber']?.errors?.required ||
            providerForm?.controls['phoneNumber']?.errors?.isValid) &&
          providerForm?.controls['phoneNumber']?.touched
        "
        class="error-msg"
      >
        Direct Phone is Required!
      </div>
      <div
        *ngIf="
          providerData.phoneNumber != 'undefined' &&
          providerData.phoneNumber != null &&
          providerData.phoneNumber != '' &&
          providerForm?.controls['phoneNumber']?.errors?.invalidPhone &&
          providerForm?.controls['phoneNumber']?.touched
        "
        class="error-msg"
      >
        Please enter a valid direct phone number!
      </div>
    </div>
  </div>
  <div class="row col-sm-12">
    <div class="form-group col-sm-4">
      <label for="emailId" class="control-label required">Direct Email </label>
      <input
        type="emailId"
        class="form-control"
        id="emailId"
        [formControl]="providerForm.controls['emailId']"
        [(ngModel)]="providerData.emailId"
        placeholder="Enter Email Id"
        required
        name="emailId"
      />
      <div
        *ngIf="
          providerForm?.controls['emailId']?.errors?.required &&
          providerForm?.controls['emailId']?.touched
        "
        class="error-msg"
      >
        Direct Email is Required!
      </div>
      <div
        *ngIf="
          providerData.emailId != 'undefined' &&
          providerData.emailId != null &&
          providerForm?.controls['emailId']?.errors?.email &&
          providerForm?.controls['emailId']?.touched
        "
        class="error-msg"
      >
        Please enter valid email address!
      </div>
    </div>
  </div>

  <div class="row form-group col-sm-12">
    <label class="col-sm-9 form-check-label" for="question1"
      >1. When did your company begin offering cable/IPTV services to customers
      in Michigan? (If you do not know the exact date, please enter an
      approximate date.)</label
    >
    <div class="col-sm-3 col-sm-no-padding-sides">
      <input
        *ngIf="isIE"
        type="date"
        class="form-control"
        id="question1"
        placeholder="mm/dd/yyyy"
        [formControl]="providerForm.controls['question1']"
        [(ngModel)]="providerData.question1"
        name="question1"
        max="9999-12-31"
      />
      <div
        *ngIf="
          isIE &&
          providerForm?.controls['question1']?.errors?.pattern &&
          providerForm?.controls['question1']?.touched
        "
        class="error-msg"
      >
        Please enter valid date(MM/DD/YYYY)!
      </div>
      <input
        *ngIf="!isIE"
        type="date"
        class="form-control"
        id="question1"
        placeholder=""
        [formControl]="providerForm.controls['question1']"
        [(ngModel)]="providerData.question1"
        name="question1"
        max="9999-12-31"
      />
      <div
        *ngIf="
          !isIE &&
          providerForm?.controls['question1']?.errors?.nativedate &&
          providerForm?.controls['question1']?.touched
        "
        class="error-msg"
      >
        Please enter valid date(MM/DD/YYYY)!
      </div>
    </div>
  </div>
  <div class="row form-group col-sm-12">
    <label for="question2" class="col-sm-9 form-check-label"
      >2. As of today, how many video/cable subscribers did your company provide
      service to in Michigan in {{ today | date: "yyyy" }} (actual
      number)?</label
    >
    <input
      type="text"
      trim="blur"
      class="form-control col-sm-3"
      id="question2"
      [formControl]="providerForm.controls['question2']"
      [(ngModel)]="providerData.question2"
      name="question2"
    />
    <div
      *ngIf="providerForm?.controls['question2']?.errors?.numeric"
      class="error-msg col-sm-offset-9"
    >
      Please enter a valid number!
    </div>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question3Group">
      <legend class="form-check-label legend-hidden">..</legend>
      <label id="question3Label" class="form-check-label">
        3. For {{ today | date: "yyyy" }}, what has been the change in the
        number of subscribers you serve compared to the total submitted in
        {{ previousYear }}?
      </label>
      <div *ngFor="let option of radioBtnOptions; let i = index" class="ml-3">
        <label for="question3{{ i }}">
          <input
            type="radio"
            (change)="resetQuestion3()"
            id="question3{{ i }}"
            name="question3Group"
            [(ngModel)]="providerData.question3"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
      <div class="form-group col-sm-12">
        <textarea
          class="form-control"
          trim="blur"
          [disabled]="providerData.question3 !== 'Other'"
          aria-label="question3Comment"
          name="question3Comment"
          [(ngModel)]="providerData.question3Comment"
          id="question3Comment"
        >
        </textarea>
        <div
          *ngIf="
            providerData.question3 === 'Other' &&
            (providerData.question3Comment === '' ||
              providerData.question3Comment === 'undefined' ||
              providerData.question3Comment === null)
          "
          class="error-msg"
        >
          This field is Required when other is checked!
        </div>
      </div>
    </fieldset>
  </div>

  <div class="row form-group col-sm-12">
    <label for="question4" class="col-sm-9 form-check-label"
      >4. How many total franchise agreements does your company have (in
      Michigan)?</label
    >
    <input
      type="text"
      trim="blur"
      name="question4"
      class="form-control col-sm-3"
      [formControl]="providerForm.controls['question4']"
      id="question4"
      placeholder=""
      [(ngModel)]="providerData.question4"
    />
    <div
      *ngIf="providerForm?.controls['question4']?.errors?.numeric"
      class="error-msg col-sm-offset-9"
    >
      Please enter a valid number!
    </div>
  </div>
  <div class="row form-group col-sm-12">
    <label class="col-sm-12 form-check-label"
      >5. How many of those franchise agreements (in Question 4) are the Uniform
      Video Service Local Franchise Agreements?</label
    >
  </div>
  <div class="row form-group col-sm-12">
    <label for="question5Uniform" class="col-sm-8 col-sm-offset-1"
      >Uniform Video Service Local Franchise Agreements
    </label>
    <input
      type="text"
      trim="blur"
      name="question5Uniform"
      class="form-control col-sm-3"
      [formControl]="providerForm.controls['question5Uniform']"
      id="question5Uniform"
      placeholder=""
      [(ngModel)]="providerData.question5Uniform"
    />
    <div
      *ngIf="providerForm?.controls['question5Uniform']?.errors?.numeric"
      class="error-msg col-sm-offset-9"
    >
      Please enter a valid number!
    </div>
  </div>
  <div class="row form-group col-sm-12">
    <label for="question5Other" class="col-sm-8 col-sm-offset-1"
      >Other franchise agreements
    </label>
    <input
      type="text"
      trim="blur"
      name="question5Other"
      class="form-control col-sm-3"
      id="question5Other"
      placeholder=""
      [(ngModel)]="providerData.question5Other"
      [formControl]="providerForm.controls['question5Other']"
    />
    <div
      *ngIf="providerForm?.controls['question5Other']?.errors?.numeric"
      class="error-msg col-sm-offset-9"
    >
      Please enter a valid number!
    </div>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question6Group">
      <legend class="form-check-label legend-hidden">6.</legend>
      <label id="question6Label" class="form-check-label">
        6. Was your company an incumbent provider prior to the effective date
        (01/01/07) of PA 480 of 2006?
      </label>
      <div *ngFor="let option of yesNoOptions; let i = index" class="ml-3">
        <label for="question6{{ i }}">
          <input
            type="radio"
            id="question6{{ i }}"
            name="question6Group"
            [(ngModel)]="providerData.question6"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
    </fieldset>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question7Group">
      <legend class="form-check-label legend-hidden">7.</legend>
      <label id="question7Label" class="form-check-label">
        7. <u>PRIOR</u> to PA 480 of 2006 (01/01/07), was your company the only
        video/cable (not satellite) provider offering service in your franchise
        areas?
      </label>
      <div *ngFor="let option of yesNoOptions; let i = index" class="ml-3">
        <label for="question7{{ i }}">
          <input
            type="radio"
            id="question7{{ i }}"
            (change)="resetQuestion7()"
            name="question7Group"
            [(ngModel)]="providerData.question7"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
    </fieldset>

    <strong class="ml-5">
      If you indicated <u class="error-msg">NO</u>, how many of your
      <i><u>franchise areas</u></i> had:
    </strong>
  </div>
  <div class="row form-group col-sm-12">
    <label for="question7a" class="control-label col-sm-8 col-sm-offset-1"
      >7a. One other competing provider (Indicate how many):
    </label>
    <input
      type="text"
      trim="blur"
      name="question7a"
      [attr.disabled]="providerData.question7 !== 'No' ? '' : null"
      [formControl]="providerForm.controls['question7a']"
      class="form-control col-sm-3"
      id="question7a"
      placeholder=""
      [(ngModel)]="providerData.question7a"
    />
    <div
      *ngIf="providerForm?.controls['question7a']?.errors?.numeric"
      class="error-msg col-sm-offset-9"
    >
      Please enter a valid number!
    </div>
  </div>
  <div class="row form-group col-sm-12">
    <label for="question7b" class="control-label col-sm-8 col-sm-offset-1"
      >7b. Two other competing providers (Indicate how many):
    </label>
    <input
      type="text"
      trim="blur"
      name="question7b"
      [attr.disabled]="providerData.question7 !== 'No' ? '' : null"
      [formControl]="providerForm.controls['question7b']"
      class="form-control col-sm-3"
      id="question7b"
      placeholder=""
      [(ngModel)]="providerData.question7b"
    />
    <div
      *ngIf="providerForm?.controls['question7b']?.errors?.numeric"
      class="error-msg col-sm-offset-9"
    >
      Please enter a valid number!
    </div>
  </div>
  <div class="row form-group col-sm-12">
    <label for="question7c" class="control-label col-sm-8 col-sm-offset-1"
      >7c. Three other competing providers (Indicate how many):
    </label>
    <input
      type="text"
      trim="blur"
      name="question7c"
      [attr.disabled]="providerData.question7 !== 'No' ? '' : null"
      [formControl]="providerForm.controls['question7c']"
      class="form-control col-sm-3"
      id="question7c"
      placeholder=""
      [(ngModel)]="providerData.question7c"
    />
    <div
      *ngIf="providerForm?.controls['question7c']?.errors?.numeric"
      class="error-msg col-sm-offset-9"
    >
      Please enter a valid number!
    </div>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question8Group">
      <legend class="form-check-label legend-hidden">8.</legend>
      <label id="question8Label" class="form-check-label">
        8. <u>SINCE</u> PA 480 of 2006 became effective (01/01/07), is there now
        a video/cable (not satellite) competitor in your approved franchise
        areas?
      </label>
      <div *ngFor="let option of yesNoOptions; let i = index" class="ml-3">
        <label for="question8{{ i }}">
          <input
            type="radio"
            id="question8{{ i }}"
            name="question8Group"
            (change)="resetQuestion8()"
            [(ngModel)]="providerData.question8"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
    </fieldset>
    <strong class="ml-5">
      If you indicated <u class="error-msg">YES</u>, how many of your
      <i><u>franchise agreement areas</u></i> today have video/cable competitors
      (not satellite)::
    </strong>
  </div>
  <div class="row form-group col-sm-12">
    <label for="question8a" class="control-label col-sm-8 col-sm-offset-1"
      >One other competing provider (How many franchise areas):
    </label>
    <input
      type="text"
      trim="blur"
      name="question8a"
      [attr.disabled]="providerData.question8 !== 'Yes' ? '' : null"
      [formControl]="providerForm.controls['question8a']"
      class="form-control col-sm-3"
      id="question8a"
      placeholder=""
      [(ngModel)]="providerData.question8a"
    />
    <div
      *ngIf="providerForm?.controls['question8a']?.errors?.numeric"
      class="error-msg col-sm-offset-9"
    >
      Please enter a valid number!
    </div>
  </div>
  <div class="row form-group col-sm-12">
    <label for="question8b" class="control-label col-sm-8 col-sm-offset-1"
      >Two other competing providers (How many franchise areas):
    </label>
    <input
      type="text"
      trim="blur"
      name="question8b"
      [attr.disabled]="providerData.question8 !== 'Yes' ? '' : null"
      [formControl]="providerForm.controls['question8b']"
      class="form-control col-sm-3"
      id="question8b"
      placeholder=""
      [(ngModel)]="providerData.question8b"
    />
    <div
      *ngIf="providerForm?.controls['question8b']?.errors?.numeric"
      class="error-msg col-sm-offset-9"
    >
      Please enter a valid number!
    </div>
  </div>
  <div class="row form-group col-sm-12">
    <label for="question8c" class="control-label col-sm-8 col-sm-offset-1"
      >Three other competing providers (How many franchise areas):
    </label>
    <input
      type="text"
      trim="blur"
      name="question8c"
      [attr.disabled]="providerData.question8 !== 'Yes' ? '' : null"
      [formControl]="providerForm.controls['question8c']"
      class="form-control col-sm-3"
      id="question8c"
      placeholder=""
      [(ngModel)]="providerData.question8c"
    />
    <div
      *ngIf="providerForm?.controls['question8c']?.errors?.numeric"
      class="error-msg col-sm-offset-9"
    >
      Please enter a valid number!
    </div>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question9Group">
      <legend class="form-check-label legend-hidden">9.</legend>
      <label id="question9Label" class="form-check-label">
        9. Have you had any informal or formal disputes with franchise entities
        regarding Uniform Video Service Local Franchise Agreements during
        {{ today | date: "yyyy" }}?
      </label>
      <div *ngFor="let option of yesNoOptions; let i = index" class="ml-3">
        <label for="question9{{ i }}">
          <input
            type="radio"
            id="question9{{ i }}"
            (change)="resetQuestion9()"
            name="question9Group"
            [(ngModel)]="providerData.question9"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
    </fieldset>
    <strong class="ml-5">
      If you indicated <u class="error-msg">YES</u>, please answer the
      following:
    </strong>
  </div>

  <div class="row form-group col-sm-12">
    <label for="question9a" class="control-label col-sm-8 col-sm-offset-1"
      >9a. How many franchise entities has your company had disputes
      with?</label
    >
    <input
      type="text"
      trim="blur"
      [attr.disabled]="providerData.question9 !== 'Yes' ? '' : null"
      [formControl]="providerForm.controls['question9a']"
      class="form-control col-sm-3"
      id="question9a"
      name="question9a"
      placeholder=""
      [(ngModel)]="providerData.question9a"
    />
    <div
      *ngIf="providerForm?.controls['question9a']?.errors?.numeric"
      class="error-msg col-sm-offset-9"
    >
      Please enter a valid number!
    </div>
  </div>

  <div class="row form-group col-sm-12">
    <label for="question9b" class="control-label col-sm-8 col-sm-offset-1">
      9b. What was the dispute(s) regarding? (Check all that apply):
    </label>
  </div>

  <div class="row form-group col-sm-12 col-sm-offset-1">
    <input
      type="hidden"
      name="question9bFranchise"
      [(ngModel)]="providerData.question9bFranchise"
    />
    <label class="col-sm-12 ml-3">
      <input
        type="checkbox"
        class="form-check-input"
        [attr.disabled]="providerData.question9 !== 'Yes' ? '' : null"
        [checked]="providerData.question9bFranchise === yesNoOptions[0].value"
        (change)="
          $event.target.checked
            ? (providerData.question9bFranchise = yesNoOptions[0].value)
            : (providerData.question9bFranchise = yesNoOptions[1].value)
        "
      />
      Franchise Fee
    </label>
    <!-- </div>
    <div class=" row form-group col-sm-12 col-sm-offset-1"> -->
    <input
      type="hidden"
      name="question9bCompleteness"
      [(ngModel)]="providerData.question9bCompleteness"
    />
    <label class="col-sm-12 ml-3">
      <input
        type="checkbox"
        class="form-check-input"
        [attr.disabled]="providerData.question9 !== 'Yes' ? '' : null"
        [checked]="
          providerData.question9bCompleteness === yesNoOptions[0].value
        "
        (change)="
          $event.target.checked
            ? (providerData.question9bCompleteness = yesNoOptions[0].value)
            : (providerData.question9bCompleteness = yesNoOptions[1].value)
        "
      />
      Completeness of the Uniform Video Service Local Franchise Agreement
    </label>
    <!-- </div>
    <div class=" row form-group col-sm-12 col-sm-offset-1"> -->
    <input
      type="hidden"
      name="question9bPeg"
      [(ngModel)]="providerData.question9bPeg"
    />
    <label class="col-sm-12 ml-3">
      <input
        type="checkbox"
        class="form-check-input"
        [attr.disabled]="providerData.question9 !== 'Yes' ? '' : null"
        [checked]="providerData.question9bPeg === yesNoOptions[0].value"
        (change)="
          $event.target.checked
            ? (providerData.question9bPeg = yesNoOptions[0].value)
            : (providerData.question9bPeg = yesNoOptions[1].value)
        "
      />
      PEG Fee
    </label>
    <!-- </div>
    <div class=" row form-group col-sm-12 col-sm-offset-1"> -->
    <input
      type="hidden"
      name="question9bForm3"
      [(ngModel)]="providerData.question9bForm3"
    />
    <label class="col-sm-12 ml-3">
      <input
        type="checkbox"
        class="form-check-input"
        [attr.disabled]="providerData.question9 !== 'Yes' ? '' : null"
        [checked]="providerData.question9bForm3 === yesNoOptions[0].value"
        (change)="
          $event.target.checked
            ? (providerData.question9bForm3 = yesNoOptions[0].value)
            : (providerData.question9bForm3 = yesNoOptions[1].value)
        "
      />
      Submission of the Attachment 3 Form
    </label>
    <!-- </div>
    <div class=" row form-group col-sm-12 col-sm-offset-1"> -->
    <input
      type="hidden"
      name="question9bMapping"
      [(ngModel)]="providerData.question9bMapping"
    />
    <label class="col-sm-12 ml-3">
      <input
        type="checkbox"
        class="form-check-input"
        [attr.disabled]="providerData.question9 !== 'Yes' ? '' : null"
        [checked]="providerData.question9bMapping === yesNoOptions[0].value"
        (change)="
          $event.target.checked
            ? (providerData.question9bMapping = yesNoOptions[0].value)
            : (providerData.question9bMapping = yesNoOptions[1].value)
        "
      />
      Mapping/Footprint Information
    </label>
    <!-- </div>
    <div class=" row form-group col-sm-12 col-sm-offset-1"> -->
    <input
      type="hidden"
      name="question9bOther"
      (change)="resetQuestion9b()"
      [(ngModel)]="providerData.question9bOther"
    />
    <label class="col-sm-12 ml-3">
      <input
        type="checkbox"
        class="form-check-input"
        [attr.disabled]="providerData.question9 !== 'Yes' ? '' : null"
        [checked]="providerData.question9bOther === yesNoOptions[0].value"
        (change)="checkQuestion9b($event.target.checked)"
      />
      <!-- (change)="$event.target.checked? (providerData.question9bOther = yesNoOptions[0].value) : (providerData.question9bOther = yesNoOptions[1].value)"> -->
      Other (briefly explain)
    </label>
    <!-- </div>
    <div class=" row form-group col-sm-10 col-sm-offset-1"> -->
    <textarea
      class="form-control col-sm-10 ml-5"
      [disabled]="providerData.question9bOther !== 'Yes' ? '' : null"
      trim="blur"
      name="question9bComment"
      aria-label="question9bComment"
      [(ngModel)]="providerData.question9bComment"
      id="question9bComment"
    >
    </textarea>
    <div
      *ngIf="
        providerData.question9bOther === 'Yes' &&
        (providerData.question9bComment === '' ||
          providerData.question9bComment === 'undefined' ||
          providerData.question9bComment === null)
      "
      class="error-msg"
    >
      This field is Required when other is checked!
    </div>
    <!-- </div>  -->
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question10Group">
      <legend class="form-check-label legend-hidden">10.</legend>
      <label id="question10Label" class="form-check-label">
        10. Did you contact the MPSC regarding the dispute?
      </label>
      <div class="form-check ml-3">
        <input
          type="radio"
          class="form-check-input"
          name="question10Group"
          [(ngModel)]="providerData.question10"
          id="question10Yes"
          value="Yes"
        />
        <label for="question10Yes"> Yes </label>
      </div>

      <div class="form-check ml-3">
        <input
          type="radio"
          class="form-check-input"
          name="question10Group"
          id="question10No"
          [(ngModel)]="providerData.question10"
          value="No"
        />
        <label for="question10No">
          No - If you answered no, please review MPSC's
          <a target="_blank"
            href="https://www.michigan.gov/mpsc/regulatory/telecommunications/video-cable"
          >
            <strong> Video/Cable Regulatory Information.</strong>
          </a>
        </label>
      </div>
    </fieldset>
  </div>

  <div class="form-group col-sm-12">
    <label for="question11" class="form-check-label"
      >11. Please provide any other comments or suggestions</label
    >
    <div class="form-group col-sm-12">
      <textarea
        class="form-control"
        trim="blur"
        name="question11"
        [(ngModel)]="providerData.question11"
        id="question11"
        [maxLength]="500"
      >
      </textarea>
    </div>
    <small> (Maximum characters : 500)</small>
  </div>

  <div class="form-group col-sm-12">
    <strong>
      Even though the following questions are optional,
      <u>we strongly encourage providers to respond</u>. This information may be
      shared in the Annual Report.
    </strong>
  </div>
  <br />
  <div class="row form-group col-sm-12">
    <label for="question12" class="col-sm-9 form-check-label">
      12. How much has your company invested in the Michigan video/cable market
      during {{ today | date: "yyyy" }} (dollar amount)?</label
    >
    <input
      type="text"
      currencyMask
      class="form-control col-sm-3"
      [(ngModel)]="providerData.question12"
      id="question12"
      name="question12"
      placeholder=""
    />
  </div>

  <div class="form-group col-sm-12">
    <label for="question13" class="form-check-label"
      >13. Please provide any improvements/enhancements made to your customer
      service in {{ today | date: "yyyy" }}.</label
    >
    <div class="form-group col-sm-12">
      <textarea
        class="form-control"
        trim="blur"
        name="question13"
        [(ngModel)]="providerData.question13"
        id="question13"
        [maxLength]="1000"
      >
      </textarea>
    </div>
    <small> (Maximum characters : 1000)</small>
  </div>

  <div class="form-group col-sm-12">
    <label for="question14" class="form-check-label"
      >14. Please provide any service offerings/technical upgrades made in
      {{ today | date: "yyyy" }}.</label
    >
    <div class="form-group col-sm-12">
      <textarea
        class="form-control"
        trim="blur"
        name="question14"
        [(ngModel)]="providerData.question14"
        id="question14"
        [maxLength]="1000"
      >
      </textarea>
    </div>
    <small> (Maximum characters : 1000)</small>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question15Group">
      <legend class="form-check-label legend-hidden">15.</legend>
      <label id="question15Label" class="form-check-label">
        15. Did your company increase employment in
        {{ today | date: "yyyy" }} as it relates to video/cable in Michigan?
      </label>

      <div class="form-check col-md-12 ml-3">
        <label class="col-md-1 col-sm-no-padding-sides" id="question15Yes">
          <input
            type="radio"
            class="form-check-input"
            name="question15Group"
            for="question15Yes"
            [(ngModel)]="providerData.question15"
            value="Yes"
          />
          Yes.
        </label>

        <label class="col-md-5" for="question15Desc">
          If yes, please provide the number of jobs added.
        </label>
        <input
          type="text"
          [attr.disabled]="providerData.question15 !== 'Yes' ? '' : null"
          trim="blur"
          class="form-control col-sm-2"
          id="question15Desc"
          [(ngModel)]="providerData.question15Desc"
          name="question15Desc"
          [formControl]="providerForm.controls['question15Desc']"
        />
      </div>
      <div
        *ngIf="providerForm?.controls['question15Desc']?.errors?.numeric"
        class="error-msg col-sm-offset-6"
      >
        Please enter a valid number!
      </div>
      <div
        *ngIf="
          providerData.question15 === 'Yes' && providerData.question15Desc <= 0
        "
        class="error-msg col-sm-offset-6"
      >
        This field is Required when yes is checked!
      </div>
      <div class="form-check col-md-12 ml-3">
        <input
          type="radio"
          (change)="resetQuestion15()"
          class="form-check-input"
          name="question15Group"
          [(ngModel)]="providerData.question15"
          id="question15No"
          value="No"
        />
        <label for="question15No"> No </label>
      </div>
    </fieldset>
  </div>

  <div class="form-group col-sm-12">
    <label for="question16" class="form-check-label"
      >16. Please provide any other improvements/enhancements/upgrades that may
      have occurred in {{ today | date: "yyyy" }}.</label
    >
    <div class="form-group col-sm-12">
      <textarea
        class="form-control"
        trim="blur"
        name="question16"
        [(ngModel)]="providerData.question16"
        id="question16"
        [maxLength]="1000"
      >
      </textarea>
    </div>
    <small> (Maximum characters : 1000)</small>
  </div>

  <div class="col-sm-12">

    <div class="form-group col-sm-12">
      <label for="Confidential"
        >If you consider any or all of the above responses to be confidential,
        please indicate which responses are confidential. (List question numbers
        below)</label
      >
      <div class="form-group col-sm-12">
        <textarea
          class="form-control"
          trim="blur"
          name="Confidential"
          [(ngModel)]="providerData.Confidential"
          id="Confidential"
        >
        </textarea>
      </div>
    </div>

    <span>
      Please review the form before submitting.
      <strong
        ><span class="underline">All required fields must be filled out.</span>
      </strong>
      By submitting, you are certifying that the foregoing responses are true
      and correct to the best of your knowledge, information, and belief. Please
      press submit only once. Once you have submitted your survey, you will
      receive a confirmation receipt that may be printed for your records. If
      this confirmation does not appear, check the required fields, as there may
      be an error.
    </span>
  </div>

  <div class="form-group col-sm-12 mt-3 text-center">
    <!-- <button type="button" (click)="Menu()" class="btn btn-dark">Back To Menu</button> -->
    <button type="submit" (click)="save()" class="btn btn-primary offset1">
      Submit
    </button>
  </div>
</div>

<div class="container" *ngIf="completionPage">
  <div class="col-sm-12">
    <strong class="col-sm-12 text-center"
      >Here is the information you have submitted.</strong
    >
    <strong class="col-sm-12 text-center"
      >Please print a copy for your records.</strong
    >
  </div>

  <div class="col-sm-12 mt-5">
    <table
      class="table table-striped table-bordered col-sm-12"
      role="presentation"
    >
      <tbody>
        <tr>
          <th class="col-sm-4"></th>
          <th class="col-sm-8"></th>
        </tr>
        <tr>
          <td>Company Name:</td>
          <td>{{ providerData.companyName }}</td>
        </tr>
        <tr>
          <td>Address:</td>
          <td>{{ providerData.address1 }}</td>
        </tr>
        <tr>
          <td>Address 2:</td>
          <td>{{ providerData.address2 }}</td>
        </tr>
        <tr>
          <td>City:</td>
          <td>{{ providerData.city }}</td>
        </tr>
        <tr>
          <td>State:</td>
          <td>{{ providerData.state }}</td>
        </tr>
        <tr>
          <td>Zip:</td>
          <td>{{ providerData.zip }}</td>
        </tr>
        <tr>
          <td>Contact Person:</td>
          <td>{{ providerData.contactPerson }}</td>
        </tr>
        <tr>
          <td>Title:</td>
          <td>{{ providerData.title }}</td>
        </tr>
        <tr>
          <td>Phone:</td>
          <td>{{ providerData.phoneNumber }}</td>
        </tr>
        <tr>
          <td>Email:</td>
          <td>{{ providerData.emailId }}</td>
        </tr>
        <tr>
          <td>Begin offering cable/IPTV services:</td>
          <td>{{ providerData.question1 }}</td>
        </tr>
        <tr>
          <td>Subscribers:</td>
          <td>{{ providerData.question2 }}</td>
        </tr>
        <tr>
          <td>Subscribers Served from last year:</td>
          <td>{{ providerData.question3 }}</td>
        </tr>
        <tr>
          <td>Subscribers Served Other:</td>
          <td>{{ providerData.question3Comment }}</td>
        </tr>
        <tr>
          <td>Total Franchise Agreements:</td>
          <td>{{ providerData.question4 }}</td>
        </tr>
        <tr>
          <td>Uniform Video Service Agreements:</td>
          <td>{{ providerData.question5Uniform }}</td>
        </tr>

        <tr>
          <td>Other Franchise Agreements:</td>
          <td>{{ providerData.question5Other }}</td>
        </tr>
        <tr>
          <td>Incumbent Provider:</td>
          <td>{{ providerData.question6 }}</td>
        </tr>
        <tr>
          <td>Only Provider:</td>
          <td>{{ providerData.question7 }}</td>
        </tr>
        <tr>
          <td>One Provider:</td>
          <td>{{ providerData.question7a }}</td>
        </tr>
        <tr>
          <td>Two Provider:</td>
          <td>{{ providerData.question7b }}</td>
        </tr>
        <tr>
          <td>Three Provider:</td>
          <td>{{ providerData.question7c }}</td>
        </tr>
        <tr>
          <td>Video Cable Competitor:</td>
          <td>{{ providerData.question8 }}</td>
        </tr>
        <tr>
          <td>One Competitor:</td>
          <td>{{ providerData.question8a }}</td>
        </tr>
        <tr>
          <td>Two Competitor:</td>
          <td>{{ providerData.question8b }}</td>
        </tr>
        <tr>
          <td>Three Competitor:</td>
          <td>{{ providerData.question8c }}</td>
        </tr>
        <tr>
          <td>Disputes {{ today | date: "yyyy" }}:</td>
          <td>{{ providerData.question9 }}</td>
        </tr>
        <tr>
          <td>Number of Disputes:</td>
          <td>{{ providerData.question9a }}</td>
        </tr>
        <tr>
          <td>Dispute Regarding:</td>
          <td>
            {{
              providerData.question9bFranchise == "Yes" ? " Franchise Fee " : ""
            }}
            {{
              providerData.question9bCompleteness == "Yes"
                ? " Completeness of the Uniform Video Service Local Franchise Agreement "
                : ""
            }}
            {{ providerData.question9bPeg == "Yes" ? "PEG Fee" : "" }}
            {{
              providerData.question9bForm3 == "Yes"
                ? " Submission of the Attachment 3 Form "
                : ""
            }}
            {{
              providerData.question9bMapping == "Yes"
                ? " Mapping/Footprint Information "
                : ""
            }}
            {{ providerData.question9bOther == "Yes" ? " Other " : "" }}
          </td>
        </tr>
        <tr>
          <td>Dispute Regarding Other:</td>
          <td>{{ providerData.question9bComment }}</td>
        </tr>
        <tr>
          <td>Contact the MPSC:</td>
          <td>
            {{ providerData.question10 }}
          </td>
        </tr>
        <tr>
          <td>Suggestions:</td>
          <td>{{ providerData.question11 }}</td>
        </tr>
        <tr>
          <td>Investment in {{ today | date: "yyyy" }}</td>
          <td>${{ providerData.question12 }}</td>
        </tr>
        <tr>
          <td>Customer service improvements in {{ today | date: "yyyy" }}:</td>
          <td>{{ providerData.question13 }}</td>
        </tr>

        <tr>
          <td>Technical upgrades in {{ today | date: "yyyy" }}:</td>
          <td>{{ providerData.question14 }}</td>
        </tr>
        <tr>
          <td>Increased employment in {{ today | date: "yyyy" }}:</td>
          <td>{{ providerData.question15 }}</td>
        </tr>
        <tr>
          <td>Number of jobs added:</td>
          <td>{{ providerData.question15Desc }}</td>
        </tr>
        <tr>
          <td>Other improvements in {{ today | date: "yyyy" }}:</td>
          <td>{{ providerData.question16 }}</td>
        </tr>
        <tr>
          <td>Confidential Questions:</td>
          <td style="word-break: break-all">
            {{ providerData.Confidential }}
          </td>
        </tr>
        <tr>
          <td>Date Submitted:</td>
          <td>{{ today | date: "MM/dd/yyyy" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="form-group col-sm-12 text-center">
    <!-- <button type="button" (click)="Menu()" class="btn btn-dark">Back To Menu</button> -->
    <button type="goBack" (click)="goBack()" class="btn btn-primary offset1">
      Back to Video Provider Survey
    </button>
  </div>
</div>
